import LotteryNumlotStatsContainer from "../../components/lottery/containers/LotteryNumlotStatsContainer";
import LotteryNumlotStatsTemplate from "../../components/lottery/templates/LotteryNumlotStatsTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function MinilotoStats() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="mlt" />
      <section className="min-h-screen">
        <LotteryNumlotStatsContainer lotteryKey="mlt" Template={LotteryNumlotStatsTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="mlt" />
    </>
  );
}
export default MinilotoStats;